import React from 'react'

export const onlineLocation = {
  address : "Westminster, London SW1A 1AA, UK",
  name : "Online",
  lat : 51.501364,
  lng : -0.1418899999999894
};